// extracted by mini-css-extract-plugin
export default {"counter":"styles_counter__jlX4X","value":"styles_value__GHhjs","title":"styles_title__SnlsW"};